import React from "react";
import { Link } from "react-router-dom";
import logo from "../../shared/logo.png";
import "./Footer.scss";
import Container from "../../shared/ui/Container";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer" role="contentinfo">
      <Container>
        <div className="footer__content">
          <div className="footer__section">
            <img
              src={logo}
              alt="Digital Access Logo"
              className="footer__logo-image"
            />

            <p className="footer__description">Digital Access For Inclusion.</p>
          </div>

          <nav className="footer__section" aria-label="Footer navigation">
            <h3 className="footer__heading">Quick Links</h3>
            <ul className="footer__links">
              <li>
                <Link to="/" className="footer__link">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="footer__link">
                  About
                </Link>
              </li>
              <li>
                <Link to="/what-we-do" className="footer__link">
                  What We Do
                </Link>
              </li>
              <li>
                <Link to="/how-it-works" className="footer__link">
                  How It Works
                </Link>
              </li>
              <li>
                <Link to="/blog" className="footer__link">
                  Blog
                </Link>
              </li>
              <li>
                <Link to="/contact" className="footer__link">
                  Contact Us
                </Link>
              </li>
            </ul>
          </nav>

          <div className="footer__section">
            <h3 className="footer__heading">Contact</h3>
            <address className="footer__address">
              <p>
                <a href="mailto:info@yourcompany.com" className="footer__link">
                  contactus@dafi.ca
                </a>
              </p>
              <p>
                <a href="tel:+1234567890" className="footer__link">
                  +1 (587) 253-8754
                </a>
              </p>
            </address>
          </div>
        </div>

        <div className="footer__bottom">
          <p className="footer__copyright">
            &copy; {currentYear} DAFI. Empowering inclusive digital experiences.
            All rights reserved.
          </p>

          <ul className="footer__legal">
            <li>
              <Link to="/privacy-policy" className="footer__link footer__link--legal">
                Privacy Policy
              </Link>
            </li>
            <li>
              <Link to="/terms-of-service" className="footer__link footer__link--legal">
                Terms of Service
              </Link>
            </li>
            <li>
              <Link to="/accessibility-statement" className="footer__link footer__link--legal">
                Accessibility Statement
              </Link>
            </li>
          </ul>
        </div>
      </Container>
    </footer>
  );
};

export default Footer;
